import Card from "./components/Card.vue";
import AIVButton from "@/components/AIVButton.vue";
import AIVDialog from "@/components/AIVDialog.vue";
import AIVRow from "@/components/AIVRow.vue";
import AIVSelect from "@/components/AIVSelect.vue";
import AIVTable from "@/components/AIVTable.vue";
import { BSpinner } from "bootstrap-vue";
import {
  Button,
  Checkbox,
  DatePicker,
  Dialog,
  Form,
  FormItem,
  Icon,
  Input,
  InputNumber,
  MessageBox,
  Notification,
  Option,
  Pagination,
  Select,
  Switch,
  Table,
  TableColumn,
  Tooltip,
  Upload,
} from "element-ui";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const GlobalComponents = {
  install(Vue) {
    Vue.prototype.$notify = function (msg, type = "info") {
      Notification({
        message: msg,
        type,
        position: "bottom-right",
        duration: 4000,
      });
    };
    Vue.prototype.$notifySuccess = function (msg) {
      this.$notify(msg, "success");
    };
    Vue.prototype.$notifyError = function (msg) {
      this.$notify(msg, "error");
    };
    Vue.prototype.$confirmAction = function (onConfirm) {
      MessageBox.confirm("Are you sure?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(onConfirm)
        .catch(() => {});
    };

    Vue.component("card", Card);
    Vue.component("AIVButton", AIVButton);
    Vue.component("AIVDialog", AIVDialog);
    Vue.component("AIVRow", AIVRow);
    Vue.component("AIVSelect", AIVSelect);
    Vue.component("AIVTable", AIVTable);
    Vue.component("BSpinner", BSpinner);
    Vue.component("el-button", Button);
    Vue.component("el-checkbox", Checkbox);
    Vue.component("el-date-picker", DatePicker);
    Vue.component("el-dialog", Dialog);
    Vue.component("el-form", Form);
    Vue.component("el-form-item", FormItem);
    Vue.component("el-icon", Icon);
    Vue.component("el-input", Input);
    Vue.component("el-input-number", InputNumber);
    Vue.component("el-option", Option);
    Vue.component("el-pagination", Pagination);
    Vue.component("el-select", Select);
    Vue.component("el-switch", Switch);
    Vue.component("el-table", Table);
    Vue.component("el-table-column", TableColumn);
    Vue.component("el-tooltip", Tooltip);
    Vue.component("el-upload", Upload);
    Vue.component("ValidationProvider", ValidationProvider);
    Vue.component("ValidationObserver", ValidationObserver);
  },
};

export default GlobalComponents;
